<template>
  <span :class="clazz">
    <slot>{{ cssVar(variable) }}</slot>
  </span>
</template>
<script lang="ts">
import { Component, Prop, Vue } from "vue-facing-decorator";

@Component({ name: "css-var" })
export default class CssVar extends Vue {
  @Prop(String)
  public readonly variable!: String;

  public clazz = "ds-css-var";

  public cssVar(name): string {
    if (name[0] === "$") {
      name = name.substring(1);
    }
    if (name[0] != "-") name = "--ng-" + name; //allow passing with or without --
    return getComputedStyle(document.documentElement).getPropertyValue(name);
  }
}
</script>
